export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10949.b494e336.jpg";